// Custom easing function for smoother scrolling
const easeOutQuart = (t) => {
  return 1 - Math.pow(1 - t, 4);
};

export const smoothScroll = (target, offset = 0) => {
  console.log('smoothScroll called with target:', target);
  
  const element = target === 'html' ? document.documentElement : document.querySelector(target);
  console.log('Element found:', element);

  if (element) {
    console.log('Starting smooth scroll animation');
    const startPosition = window.pageYOffset;
    const elementPosition = element === document.documentElement ? 0 : element.getBoundingClientRect().top;
    const targetPosition = elementPosition + startPosition - offset;
    const distance = targetPosition - startPosition;
    const duration = Math.min(Math.abs(distance) * 0.5, 800); // Dynamic duration based on distance
    let start = null;

    const animation = (currentTime) => {
      if (start === null) start = currentTime;
      const timeElapsed = currentTime - start;
      const progress = Math.min(timeElapsed / duration, 1);
      const easedProgress = easeOutQuart(progress);
      
      window.scrollTo(0, startPosition + distance * easedProgress);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  } else {
    console.log('No element found for target:', target);
  }
};

export const scrollToTop = () => {
  const startPosition = window.pageYOffset;
  const duration = Math.min(startPosition * 0.3, 600); // Dynamic duration based on distance
  let start = null;

  const animation = (currentTime) => {
    if (start === null) start = currentTime;
    const timeElapsed = currentTime - start;
    const progress = Math.min(timeElapsed / duration, 1);
    const easedProgress = easeOutQuart(progress);
    
    window.scrollTo(0, startPosition * (1 - easedProgress));

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  };

  requestAnimationFrame(animation);
};

export const scrollToBottom = () => {
  const startPosition = window.pageYOffset;
  const targetPosition = document.documentElement.scrollHeight;
  const distance = targetPosition - startPosition;
  const duration = Math.min(Math.abs(distance) * 0.5, 800); // Dynamic duration based on distance
  let start = null;

  const animation = (currentTime) => {
    if (start === null) start = currentTime;
    const timeElapsed = currentTime - start;
    const progress = Math.min(timeElapsed / duration, 1);
    const easedProgress = easeOutQuart(progress);
    
    window.scrollTo(0, startPosition + distance * easedProgress);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  };

  requestAnimationFrame(animation);
}; 